import { useSelector } from 'react-redux';

const SUPPORT_TRAINING_USER = 'support+training_user@videa.ai';

/**
 * Helper function to check if a user is the support training user (support+training_user@videa.ai).
 * Can be used in non-React contexts (e.g., callbacks, utilities).
 */
export const isSupportTrainingUser = (username?: string): boolean => {
  return username === SUPPORT_TRAINING_USER;
};

/**
 * Helper function to check if a user is a sales demo training user.
 * Can be used in non-React contexts (e.g., mock handlers, utilities).
 * For React components, prefer using the useIsSalesDemoTrainingUser hook.
 *
 * Always returns false when VITE_SALES_DEMO_ENV is not set (i.e., on prod/develop).
 */
export const isSalesDemoTrainingUser = (username?: string): boolean => {
  if (!process.env.VITE_SALES_DEMO_ENV) return false;
  return username?.includes('hd_training') ?? false;
};

/**
 * Always returns false when VITE_SALES_DEMO_ENV is not set (i.e., on prod/develop).
 */
export const isHenryScheinSalesUser = (username?: string): boolean => {
  if (!process.env.VITE_SALES_DEMO_ENV) return false;
  return username === 'henry_schein_sales@videa.ai';
};

export const useIsHenryScheinSalesUser = (): boolean => {
  const user = useSelector((state: any) => state.login?.user);
  return isHenryScheinSalesUser(user?.username);
};

export const useIsSalesDemoTrainingUser = (): boolean => {
  const user = useSelector((state: any) => state.login?.user);
  return isSalesDemoTrainingUser(user?.username);
};
